import { Link } from 'react-router-dom'
import Label from '../../components/label/label';
import Input from '../../components/input/input';
import Button from '../../components/button/button';
import { useState } from 'react';
import PasswordInput from '../../components/passwordInput/passwordInput';
import { useLogin } from '../../hooks/useLogin';
import './login.css'

function Register() {
    const [name, setName] = useState('');
    const [prename, setPrename] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const { handleRegister } = useLogin();

    return (
        <div className='loginPageContainer'>
            <div className='loginCard'>
                <h1>Account erstellen</h1>
                <form onSubmit={(e) => handleRegister(e, prename, name, email, password, passwordConfirm)} className='loginForm'>
                    <Label labelFor="prename" labelValue="Vorname:" />
                    <br />
                    <Input
                        borderColor='black'
                        inputType="text"
                        inputId="prename"
                        inputName="prename"
                        inputValue={prename}
                        onChange={(e) => setPrename(e.target.value)}
                        width='100%'
                    />
                    <br />
                    <Label labelFor="name" labelValue="Nachname:" />
                    <br />
                    <Input
                        borderColor='black'
                        inputType="text"
                        inputId="name"
                        inputName="name"
                        inputValue={name}
                        onChange={(e) => setName(e.target.value)}
                        width='100%'
                    />
                    <br />
                    <Label labelFor="email" labelValue="Email:" />
                    <br />
                    <Input
                        borderColor='black'
                        inputType="text"
                        inputId="email"
                        inputName="email"
                        inputValue={email}
                        onChange={(e) => setEmail(e.target.value)}
                        width='100%'
                    />
                    <br />
                    <PasswordInput
                        labelFor='password'
                        labelValue='Passwort: '
                        inputId='password'
                        inputValue={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        borderColor='black'
                        width='100%'
                    />
                    <PasswordInput
                        labelFor='passwordConf'
                        labelValue='Passwort bestätigen: '
                        inputId='passwordConf'
                        inputValue={passwordConfirm}
                        onChange={(e) => setPasswordConfirm(e.target.value)}
                        required
                        borderColor='black'
                        width='100%'
                    />
                    <br />
                    <Input
                        borderColor='black'
                        inputType="submit"
                        inputId="submit"
                        inputName="submit"
                        inputValue="Anmelden"
                        height='50px'
                        width='100%'
                    />
                </form>
                <p>Du hast schon einen Account?</p>
                <Link to="/login">
                    <Button buttonValue='Hier anmelden' />
                </Link>
            </div>
        </div>
    );
}

export default Register;